import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTrustedshopsComponent } from './simple-icons-trustedshops.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTrustedshopsComponent ],
    exports:      [ SimpleIconsTrustedshopsComponent ],
    bootstrap:    []
})
export class SimpleIconsTrustedshopsModule {}
